var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiddingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_13455_161399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7867 0L24 5.21333V32H0V0H18.7867Z",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.998 10.5263V5.33301H18.8047",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.8047 0V5.19333H23.998",
    fill: "#7EB3FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.0195 14.1797H19.3529",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0195 11.5127H20.6862",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.35156 19.5127H20.0182",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.35156 22.1797H20.0182",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.35156 24.8467H20.0182",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.6875 19.5127H6.02083",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M4.6875 22.1797H6.02083",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4.6875 24.8467H6.02083",
    stroke: "#7EB3FF",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.0182 14.8467V13.5133C12.0182 12.04 10.8249 10.8467 9.35156 10.8467H6.01823C4.5449 10.8467 3.35156 12.04 3.35156 13.5133V14.8467H12.0182Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M7.6849 10.1794C8.97356 10.1794 10.0182 9.13469 10.0182 7.84603C10.0182 6.55736 8.97356 5.5127 7.6849 5.5127C6.39623 5.5127 5.35156 6.55736 5.35156 7.84603C5.35156 9.13469 6.39623 10.1794 7.6849 10.1794Z",
    fill: "#0561FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13455_161399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddingIcon);
export default __webpack_public_path__ + "static/media/bidding-icon.01fd162ed2732ed9030cd2bdf00139d7.svg";
export { ForwardRef as ReactComponent };